module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTRODUCTION")])])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAT")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("F")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERE")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERE")]), _vm._v(" N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("O")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USIC?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("What if there were no music at all in this world? Can you imagine such a development? No music, no concerts, no records, no karaoke, no CDs. No songs to sing. No music programs on the radio or television. It’s difficult to even imagine. Without music, the world would be a boring place. Just thinking about such a world makes me depressed and stressed. Music has become such an integral part of our daily life that we can’t live without it.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAT")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USIC?")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("In Japanese, we write the word "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("music")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "height": "12",
      "src": "images/f0vii-01.jpg",
      "width": "30"
    }
  }), _vm._v(" as “enjoyment” "), _c('img', {
    attrs: {
      "alt": "images",
      "height": "12",
      "src": "images/f0vii-02.jpg",
      "width": "18"
    }
  }), _vm._v(" of “sounds” "), _c('img', {
    attrs: {
      "alt": "images",
      "height": "13",
      "src": "images/f0vii-03.jpg",
      "width": "20"
    }
  }), _vm._v(". What is a sound? A sound invariably occurs wherever there is a vibration, so we could say that a sound is a vibration. (Although humans only hear sounds generated by vibrations between 15 Hz and 20,000 Hz, which are called audible sounds, all vibrations emit sounds.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What, then, is a vibration? It is energy itself, moving through matter. As waves of energy disturb particles of matter, the particles move, like floating balls on water, going up and down with the wave pattern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Music, then, is an art form through which we experience vibrations, which is actually energy itself.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YMPHONY")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NSIDE")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UR")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ODY")])])])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Our body is composed of upwards of 100 trillion cells. Surprisingly, the vibration of each cell is slightly different from those of other cells. This means that ")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("each cell is generating a slightly different sound. With so many cells in our body, if we could use a high-quality microphone to collect all these sounds, we would hear a great symphony that is constantly being played inside our body.")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In my research of vibrations within the body, I have found that the origin of any disease is a disturbance in the frequency within each cell. We could say that the more harmonious and the more beautiful our body’s symphony is, the healthier both the body and mind should become. Conversely, when discordant vibrations increase, our body and mind will turn negative and finally a disease will become manifest. For this reason, great doctors of “the good ol’ days” were able to find abnormalities in the body of a patient with only the help of a stethoscope.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTROLLING A")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBRATION")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ITH")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOTHER")]), _vm._v(" V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IBRATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("It is not difficult to restore a distorted sound to its normal state: one can simply measure the wave form of the existing sound, shift its phase ninety degrees (that is, curving “down” where the original is curving “up”), and then play it alongside the original sound. The distorted sound will be cancelled out and no sound will be heard. This technology has already been applied to reduce the noise generated from the engine of a car.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reason that we need music resides in this principle. The stresses of modern society distort the vibrations of the cells in our body. To assist these distorted vibrations in returning to normal, we choose music—vibrations—with the right rhythm, tempo, tone, and melody to cancel out the distortion. For this reason, music has been our companion since the dawn of human history, in many different forms, and continues to give us healing effects.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("“S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EEING")]), _vm._v("” M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USIC")])])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Music is meant to be heard. But using the technique of water-crystal photography that I developed years ago, it is possible to “see” music. It works in the following manner: a water crystal is a geometrical design shaped by a vibration, and a sound is a vibration. So if you listen to a piece of music and look at the water crystal created by the vibration of that music simultaneously, you can “see” the vibrational pattern of the music in the crystal and absorb all the vibrations into your body through your eyes and ears.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USIC")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERAPY")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Organs and diseases have measurable "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hado")]), _vm._v(", a subtle form of energy that is easily transmittable and present in all things. In English, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hado")]), _vm._v(" translates as “wave motion” or “vibration.” In the near future, as research progresses, the hado associated with all organs and diseases will become clear and widely understood. Then, it will become possible to compose music that has vibrations and rhythm corresponding to a certain organ or disease—for example, a piece of music that can cancel the hado of liver cancer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I imagine that, at some future time, the technology to help people absorb beneficial vibrations will be widely adopted. When that day comes, a water-crystal representation of a piece of music will be placed on the music’s packaging, and listeners will be able to enjoy music that is composed of the vibrations that are most beneficial to them. They will select music with the water-crystal image they are most attracted to at that moment and will receive healing effects from “seeing” as well as “hearing” the vibration. While enjoying the music, listeners can not only reduce their diseases but also prevent them.")])]), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HIS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("USIC")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERIES")])])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Until such a day arrives, I have collected these pieces of classical music, which my research has shown to produce beautiful crystals that suggest healing and well-being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d like to describe the process of this research. We start with the premise that water has an ability to memorize various kinds of information. Because music is a assemblage of vibrations, it can be said that the difference in separate pieces of music is the difference in vibration. Water-crystal photography is a technique that can express the quality of each piece of music with a visual image. The water-crystal photographs in this collection of music were taken after each piece of music was played to distilled water. Here is a brief explanation of how we do this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "numberlistc1"
  }, [_vm._v("1. First, we play each piece of music with a set of speakers to the vial filled with distilled water.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlistc"
  }, [_vm._v("2. We place about 1 ml of the water sample onto each petri dish. We do this with fifty dishes for each water sample.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlistc"
  }, [_vm._v("3. We freeze the water contained in the fifty petri dishes at a temperature of -25 to -30 degrees centigrade.")]), _vm._v(" "), _c('p', {
    staticClass: "numberlistc"
  }, [_vm._v("4. Illuminating the frozen ice on each petri dish under a light microscope, we observe each water crystal and take sequence photographs with a magnification of 100X to 200X. These observations and photographs are made inside a large, cold room at -5 degrees centigrade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("It is the tip of the frozen and expanded ice that produces a water crystal. The ice block that is taken out of the freezer melts gradually because of the ")]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("temperature difference and the light from the microscope. At this moment, the water crystal at the tip of the ice block shows the expression of water that has resonated with each beautiful piece of music. The technique of water-crystal photography can capture this moment as a picture. We continue to take beautiful images that complement each selection of excellent music we test.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But that is not all. The next step is to measure the hado contained in a water-crystal photograph. Let me explain how I came to measure the hado of photographs. For over fifteen years, I have successfully used a hado-measuring device, called a Magnetic Resonance Analyzer (MRA), to measure the characteristics of hado and adjust the balance of the human energy field. To do a hado measurement on a person, the client places his or her palm on the MRA’s measuring plate. I have found that if the client cannot be there in person, a photograph of the client works equally well in getting a hado measurement. Once the hado has been assessed, we can transfer to water a hado that counteracts any negative hado generated with the MRA. This is possible because water can memorize hado, which is vibration. The client then drinks the hado water, which corrects the disturbance in his or her energy balance, activates immunity, and facilitates self-healing power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now, let’s return to music. When we began to measure the hado of a piece of music, we found it difficult to do so directly, because music has no visible form. However, it became possible to measure the hado of music by measuring the hado of the water-crystal photographs of water that was exposed to the piece of music. By combining the water-crystal photography and hado-measuring techniques, the healing effects of music become very clear and concrete.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("My associates and I exposed water to pieces of music, observed the resulting water crystals, and took photographs. At the same time, we measured characteristics of the hado of each photograph with the MRA. Based on the hado data, we could infer the potential healing effects of each piece of music in terms of its hado effect.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In our experiments, we used timeless pieces of music that have resonated well with people for many years. Accompanying the photographs is a brief history of each musical selection and its composer so that you can connect with the emotions and hado of the original composer while you fully enjoy the music.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To use this book and accompanying music, please read each piece’s history and hado qualities first and then enjoy both the lovely music and the corresponding beautiful water-crystal photographs. As you do so, visualize each organ in your body, as described in the commentary, with great appreciation for the organ. The concentration of consciousness created by visualizing each organ and the wonderful, beneficial synthesis between seeing and hearing can impart healing effects unlike any you have previously experienced.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322f22f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05.vue
// module id = 66
// module chunks = 0